import React, { useContext, useEffect, useState } from "react";
import { Card, Container } from "react-bootstrap";
import Footer from "../components/footer/Footer";
import AppNavbar from "../components/header/AppNavbar";
import BottomTabNavigator from "../components/header/BottomTabNavigator";
import RentNow from "../components/modals/RentNow";
import AppContext from "../context/AppContext";
import { FaCartArrowDown } from "react-icons/fa";
import Wave from "react-wavify";

const MasterLayout = ({ children }) => {
  const { isDesktopOrLaptop, navigate } = useContext(AppContext);
  const [isScrolled, setIsScrolled] = useState(false);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 350) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <Container
      style={{ backgroundColor: "#f0f2f6" }}
      fluid
      className="p-0 m-0 d-flex flex-column"
    >
      {/* <TopBanner /> */}
      <AppNavbar />
      <main className="">{children}</main>
      <>
        <Card
          className="bg-green shadow-lg mt-5 border-0"
          style={{
            position: "fixed",
            right: "5%",
            bottom: "20%",
            borderRadius: "100%",
            cursor: "pointer",
            overflow: "hidden",
          }}
        >
          <Wave
            fill="#1A94DD"
            paused={false}
            style={{
              height: isDesktopOrLaptop ? 80 : 50,
              width: isDesktopOrLaptop ? 80 : 50,
              borderRadius: 100,
            }}
            options={{
              // height: 20,
              amplitude: 25,
              speed: 0.15,
              points: 3,
            }}
          />
        </Card>
        <Card
          onClick={() => {
            navigate("/cart");
          }}
          className="d-flex flex-column justify-content-center align-items-center"
          style={{
            height: isDesktopOrLaptop ? 80 : 50,
            width: isDesktopOrLaptop ? 80 : 50,
            position: "fixed",
            right: "5%",
            bottom: "20%",
            borderRadius: "100%",
            cursor: "pointer",
            overflow: "hidden",
            backgroundColor: "transparent",
            borderWidth: 0,
          }}
        >
          <FaCartArrowDown size={"1.2rem"} className="text-white" />
        </Card>
      </>

      <BottomTabNavigator />
      <Footer />

      {/* Rent Now Modal */}
      <RentNow isVisible={showModal} hideModel={() => setShowModal(false)} />
    </Container>
  );
};

export default MasterLayout;
